import { BodyCopy } from 'Components/shared/BodyCopy';
import * as React from 'react';
import { Popup } from 'semantic-ui-react';
import { Styled } from './index.styles';
import { ChatLayoutHeaderTextProps } from './types';

export const ChatLayoutHeaderText: React.FC<ChatLayoutHeaderTextProps> = ({
  title,
  subtitle = '',
  thirdline = '',
  emoji,
}) => (
  <>
    <Styled.Wrapper>
      <Styled.Heading variant="h5" noMargin>
        {title}
      </Styled.Heading>
      {subtitle && <BodyCopy noMargin ellipsis title={subtitle}>{subtitle}</BodyCopy>}
      {thirdline && <BodyCopy noMargin ellipsis title={thirdline}>{thirdline}</BodyCopy>}
    </Styled.Wrapper>
    {emoji?.title && (
      <Popup
        inverted
        trigger={<Styled.Emoji>{emoji.title}</Styled.Emoji>}
        content={emoji?.message}
        position="top right"
      />
    )}
  </>
);
